
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M14.413 12.549a4.97 4.97 0 01-1.955-.391l.22-1.211c.593.289 1.226.482 1.755.482.331 0 .551-.105.551-.325 0-.206-.137-.308-.866-.542-1.074-.366-1.55-.695-1.55-1.569 0-1.026.825-1.542 1.859-1.542.742 0 1.197.122 1.7.358l-.22 1.195c-.523-.28-1.054-.424-1.454-.424-.342 0-.509.102-.509.273 0 .194.132.298.752.483 1.184.38 1.664.77 1.664 1.59 0 1.176-.887 1.623-1.947 1.623zm-5.406-.053V7.504h1.486v3.732h1.536l.2 1.26H9.007zm-1.963.046l-.984-1.63-.929 1.584H3.638l1.604-2.514-1.48-2.284 1.576-.24.86 1.466.813-1.42h1.5l-1.493 2.35 1.609 2.455-1.583.233zM17 4H2v12h16V5c0-.551-.449-1-1-1z"}})])
          )
        }
      }
    